import { inject, Injectable } from '@angular/core';
import { DashboardInfoContainer } from '../../domain/model/dashboard-info-container.model';
import { ErzeugungsanlageService } from '../erzeugungsanlage/erzeugungsanlage.service';
import { NetzzuordnungService } from '../netzzuordnung/netzzuordnung.service';
import { PlanwertService } from '../planwert/planwert.service';
import { TnbUser } from '../auth/tnb-user';
import { PlanwertFilter } from '../planwert/planwert-filter';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class DashboardInfoService {

    private erzeugungsanlageService = inject(ErzeugungsanlageService);
    private netzzuordnungService = inject(NetzzuordnungService);
    private planwertService = inject(PlanwertService);
    private http = inject(HttpClient);

    getDashboardInfo(tnbUser: TnbUser, selectedStadtwerkId: string, planwerteFilter: PlanwertFilter): Observable<DashboardInfoContainer> {
        if (tnbUser.netzbetreiberType === 'STADTWERK') {

            return combineLatest([
                this.erzeugungsanlageService.getSnapshot(selectedStadtwerkId),
                this.netzzuordnungService.getSnapshot(selectedStadtwerkId),
                this.planwertService.getSnapshot(planwerteFilter),
            ]).pipe(
                map(([
                    erzeugungsanlageSnapshot,
                    netzzuordnungSnapshot,
                    planwertSnapshot,
                ]) => {
                    return {
                        erzeugungsanlage: erzeugungsanlageSnapshot,
                        netzzuordnung: netzzuordnungSnapshot,
                        planwerte: planwertSnapshot,
                        netzzuordungImport: null,
                        unbestaetigteUuids: null,
                        dienstleistungsarten: null,
                    };
                }),
            );
        } else {
            return this.getDashboardInfoForWestnetz();
        }
    }

    private getDashboardInfoForWestnetz(): Observable<DashboardInfoContainer> {
        return this.http.get<DashboardInfoContainer>('api/dashboard/westnetz');
    }
}
